import jsPDF from "jspdf";
import { C, PdfWriter } from "../../BalanceSheet/utils/pdfParts";
import { BriefReport } from "../types";

/**
 * Monthly Brief Report PDF: a title block, then one month section per page
 * (heading, 4 summary boxes, equation, Detailed Income, Detailed Expenses).
 * Draws the normalized backend data as given — nothing is recalculated.
 */
export const buildBriefPdf = (report: BriefReport, generatedAt: Date = new Date()): jsPDF => {
  const w = new PdfWriter();

  report.sections.forEach((section, i) => {
    if (i === 0) {
      w.centered(report.project.name, 16, C.text, true, 6);
      w.centered("Monthly Brief Report", 11, C.slate);
      w.centered(report.label, 9.5, C.muted, false, 8);
    } else {
      // One month per page; a small running header keeps each page identifiable.
      w.newPage();
      w.centered(`${report.project.name}  |  Monthly Brief Report  |  ${report.label}`, 8, C.muted, false, 7);
    }

    w.sectionTitle(section.label, 40, 13);
    w.y += 3;
    w.summaryBoxes(section);
    w.incomeAndExpenseTables(section);
  });

  w.footers(`${report.project.name} - Monthly Brief Report - ${report.label}`, generatedAt);
  return w.doc;
};

export const briefFileName = (report: BriefReport) => {
  const first = report.sections[0];
  const last = report.sections[report.sections.length - 1];
  const period =
    report.mode === "monthly"
      ? first.startDate.slice(0, 7)
      : report.mode === "three_months"
      ? `${first.startDate.slice(0, 7)}_to_${last.endDate.slice(0, 7)}`
      : `${first.startDate}_to_${last.endDate}`;
  return `${report.project.name.replace(/[^A-Za-z0-9]+/g, "_")}_Monthly_Brief_${period}.pdf`;
};

export const downloadBriefPdf = (report: BriefReport) => buildBriefPdf(report).save(briefFileName(report));
